export const ACCEPTABLE_CONNECTION_TIME = 400;
export const NOTIFICATION_NEXT_ACTIVE_TIME = 600000;
